import { render, staticRenderFns } from "./page-blog-list-sidebar.vue?vue&type=template&id=22b996b8&"
import script from "./page-blog-list-sidebar.vue?vue&type=script&lang=js&"
export * from "./page-blog-list-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports